import { Atom, Data } from "@cirrus/fe-lib"

import * as profile from "./profile.js"
import * as settings from "./settings.js"
import { selectors } from "./selectors.js"

export const CurrentUserModel = {
  actions: Data.merged(profile.actions, settings.actions),
  atom: Atom.from(profile, settings),
  effects: [...profile.effects, ...settings.effects],
  state: selectors,
}
